// Deleting a saved scenario asks first (TX-US-0026). The same modal every other confirmation uses;
// a refusal stays in the dialog beside the button that was refused.

import { useState } from 'react';

import { deleteScenario } from '../api.js';
import Modal from '../ui/Modal.jsx';

export default function DeleteScenarioDialog({ modelId, scenario, onClose, onDeleted }) {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);

  const onSubmit = async (event) => {
    event.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await deleteScenario(modelId, scenario.scenario_id);
      onDeleted(scenario);
    } catch (err) {
      setError(
        err.status === 403 ? 'Only the person who saved a scenario may delete it.' : err.message,
      );
      setBusy(false);
    }
  };

  return (
    <Modal onClose={onClose}>
      <form onSubmit={onSubmit}>
        <h3>Delete “{scenario.name}”?</h3>
        <p className="hint">The scenario is removed for everyone. This cannot be undone.</p>
        {error && <p className="error">{error}</p>}
        <menu>
          <button type="button" onClick={onClose} disabled={busy}>Cancel</button>
          <button type="submit" disabled={busy}>{busy ? 'Deleting…' : 'Delete'}</button>
        </menu>
      </form>
    </Modal>
  );
}
